<template lang="pug"> 
  title-tab(
    :msg="$t('title.lottery-online')"
    :had-data='hadData'
  )
    template(#bottomAppend)
      //- card-credit
    template(
        v-for='(item,i) in AllLotto'
        v-if='hadData'
    )
      card-form(
        :key='i'
        :transfer-data='item'
        :name-bet='item.name'
        ref='cardForm'
        @sortdata='sortdata'
      )
      n-empty(v-if='AllLotto.length===0') 

</template> 
<script>
import { gameRounds as apiGameRounds } from '@/apis' 
import CardForm from './childs/CardForm' 
import CardCredit from './childs/CardCredit'
import * as c from '@/const/setTimeOutConfig' 
import { IsYeekeeType } from '@/const/gameId' 

export default {
  components:{ 
    CardForm, 
    CardCredit
  },  
  data: () => ({  
    hadData:false, 
    AllLotto:[],  
    fetchTimeout:null 
  }),

  async created () {     
    await this.load()
  },  

  methods : { 
    async load () { 
      this.hadData = false
      const [err,data] = await apiGameRounds.get()
      this.hadData = true   
     
      if(err){
        this.$alert('',err,'warning') 
        return
      }
      //map status for expand button 
      this.AllLotto = data.map(element=>{
        element.expand = false
        return element
      }) 

      let yeekeeRound =  data.filter(x=>IsYeekeeType(x.id)) 
      localStorage.setItem('yeekeeRound',JSON.stringify(yeekeeRound))
    },
    sortdata () {
      if(this.fetchTimeout){ 
        clearTimeout(this.fetchTimeout)
      }
      this.fetchTimeout = setTimeout(()=>{  
        this.load()
      },c.DEBOUNCEFETCHGAME) 
      //sort with urself here !!!
      // this.AllLotto = this.AllLotto.forEach(element=>{
      //   element.game_rounds.sort((a,b)=>a.locked_at-b.locked_at)
      // })
    },
  }
}
</script> 